module.exports = __webpack_public_path__ + "img/logo_sibils.f90237e6.png";